import createSagaMiddleware from 'redux-saga'

const SagaMiddleware = createSagaMiddleware()

export default SagaMiddleware
